import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWSL5 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Lionesses in Honours List",
            author: "footballgirl",
            date: "January, 2026",
            image: "images/wsl/5a.jpg",
            content: `<p>Several members of the Lionesses squad have been 
            recognised in the King’s New Year Honours List 2026 
            for their outstanding contributions to association football 
            and the growth of women’s sport. These honours follow England’s
             triumphant campaign at UEFA Women’s EURO 2025, where the
              Lionesses defended their European title, significantly raising 
              the profile of women’s football both domestically and internationally.
               </p> <p>England head coach 
               Sarina Wiegman was awarded an honorary
                DBE (Dame Commander of the Order of the British Empire) 
                for her services to football and international sport. 
                The honorary damehood recognises 
            her leadership in guiding the Lionesses to successive 
            European Championships and her role in advancing women’s 
            football in England. </p>
             <p>Lionesses captain Leah Williamson received a 
             CBE (Commander of the Order of the British Empire). 
             Williamson has been a central figure in the team’s 
             leadership on and off the pitch, and her influence extends 
             to her successful club career, including captaining 
             Arsenal to a UEFA Women’s Champions League victory in 2025.
              </p> <p>Four additional Lionesses 
              — Alex Greenwood, Keira Walsh, Georgia Stanway and Ella 
              Toone** — were each appointed MBE (Member of the Order 
              of the British Empire) in recognition of their integral
               roles during the EURO 2025 campaign. Their tactical 
               contributions and consistent performances helped England 
               secure victory and elevate the profile of the women’s game.</p>
                <p>Beyond players,
                Dr Ritan Mehta, England women’s long-serving team doctor 
                and head of women’s medical at the FA, also received an MBE 
                for over ten years of service supporting the Lionesses. 
                </p> <p>The list further 
                honours Kerry Davis, England’s first Black women’s international 
                and one of the country’s most prolific goal-scorers during her
                 era, with an MBE for her contributions to both football and diversity
                  in sport. </p> <p>Overall, 
                  the King’s New Year Honours List recognises achievements across
                   public life, celebrating those who have made exceptional
                    contributions to sport, culture and community service 
                    in the United Kingdom. </p>`,
            tags: ["England", "Lionesses", "Honours"],
            navIndices: { prev: 'wsl-4', next: 'wsl-6' }
        });
    }

    init() {
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WSL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wslnews' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) { leagueLogo.src = '/images/league_wsl.png'; leagueLogo.alt = 'WSL'; }
    }
}